module.exports = __webpack_public_path__ + "img/category-casino-hover.23428efa.png";